/*
 * MOTUS: "Dodaj" przy produktach w "Może Ci się spodobać" w szufladzie koszyka (Z-CRO-43, 17.10.2026).
 * Markup: snippets/motus-koszyk-polecane.liquid (z product-card-horizontal przy motus_cart_add). Wygląd: motus-custom.css sekcja 64.
 * Ładowany w sections/cart-drawer.liquid obok cart.js.
 *
 * Dodanie: /cart/add.js z sekcjami koszyka (zdarzenie Concepta cart:bundled-sections), potem theme.pubsub cartUpdate
 * z cart.sections, jak natywny product-form Concepta: Concept sam podmienia szufladę (lista, pasek darmowej dostawy, suma)
 * i licznik w nagłówku, a "Może Ci się spodobać" doładowuje się od nowa bez dodanego produktu.
 * Po odświeżeniu szuflada zostaje przewinięta do tego samego miejsca (nagłówek polecanych), a fokus wraca do polecanych.
 * Wybór wariantu: pigułki (radio), wyprzedane wyłączone w Liquid; zmiana podmienia zdjęcie wiersza, cenę i etykietę przycisku.
 * W-31 (18.10.2026): te same wiersze rysuje blok "Akcesoria" (snippets/motus-koszyk-akcesoria.liquid). Gdy po dodaniu
 * blok znika z szuflady (hulajnoga ma już akcesorium), przewijamy do dodanej pozycji, tak jak przy pustych polecanych.
 */
(() => {
  if (window.motusKoszykPolecane) return;
  window.motusKoszykPolecane = true;

  const PANEL = '[data-motus-polecane]';
  const BUTTON = '[data-motus-polecane-dodaj]';
  const RADIO = `${PANEL} input[type="radio"]`;
  const RECS = 'product-recommendations';
  let busy = false;

  const sectionsToRender = () => {
    const sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections } }));
    return Array.from(new Set(sections));
  };

  const announce = (host, text) => {
    if (!host) return;
    let region = host.querySelector(':scope > .motus-polecane-live');
    if (!region) {
      region = document.createElement('p');
      region.className = 'motus-polecane-live sr-only';
      region.setAttribute('role', 'status');
      host.appendChild(region);
    }
    region.textContent = '';
    setTimeout(() => { region.textContent = text; }, 100);
  };

  const setLoading = (button, on) => {
    const loader = button.querySelector('.motus-polecane__loader');
    if (on) {
      button.setAttribute('aria-busy', 'true');
      button.setAttribute('aria-disabled', 'true');
    } else {
      button.removeAttribute('aria-busy');
      button.removeAttribute('aria-disabled');
    }
    if (loader) loader.hidden = !on;
  };

  // Karuzela Concepta ma adaptiveHeight: po pokazaniu albo schowaniu komunikatu przelicz wysokość.
  const resizeCarousel = (panel) => {
    const carousel = panel && panel.closest('product-complementary');
    try { carousel && carousel.carousel && carousel.carousel.slider && carousel.carousel.slider.resize(); } catch (e) {}
  };

  const showError = (panel, text) => {
    const error = panel && panel.querySelector('.motus-polecane__blad');
    if (!error) return;
    error.textContent = text;
    error.hidden = !text;
    resizeCarousel(panel);
  };

  // Concept zdejmuje tabindex tylko z przycisków i linków aktywnego slajdu; pigułki (radio) obsługujemy tak samo.
  const syncTabindex = (carousel) => {
    const index = parseInt(carousel.getAttribute('selected-index'), 10) || 0;
    Array.from(carousel.children).forEach((slide, i) => {
      slide.querySelectorAll(`${PANEL} input[type="radio"]`).forEach((input) => {
        if (i === index) input.removeAttribute('tabindex');
        else input.setAttribute('tabindex', '-1');
      });
    });
  };
  new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      if (m.target instanceof Element && m.target.matches('product-complementary')) syncTabindex(m.target);
    });
  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['selected-index'] });

  document.addEventListener('change', (event) => {
    const input = event.target instanceof HTMLInputElement && event.target.matches(RADIO) ? event.target : null;
    if (!input || !input.checked) return;
    const panel = input.closest(PANEL);
    const row = panel.closest('.horizontal-product');
    const button = panel.querySelector(BUTTON);
    if (button) {
      button.setAttribute('data-variant-id', input.value);
      button.setAttribute('aria-label', `${((window.motusTeksty || {}).dodajAria || 'Dodaj do koszyka: {nazwa}').replace('{nazwa}', () => button.getAttribute('data-motus-nazwa') || '')}, ${input.getAttribute('data-motus-wariant') || ''}`);
    }
    const img = row && row.querySelector('.horizontal-product__media img');
    const src = input.getAttribute('data-motus-obraz');
    if (img && src) {
      const srcset = input.getAttribute('data-motus-obraz-srcset');
      if (srcset) img.setAttribute('srcset', srcset);
      img.setAttribute('src', src);
      if (input.hasAttribute('data-motus-obraz-alt')) img.setAttribute('alt', input.getAttribute('data-motus-obraz-alt'));
    }
    const template = panel.querySelector(`template[data-motus-cena="${CSS.escape(input.value)}"]`);
    const price = panel.querySelector('[data-motus-polecane-cena]');
    if (template && price) price.replaceChildren(template.content.cloneNode(true));
    showError(panel, '');
  });

  // Po podmianie szuflady przez Concepta: to samo miejsce przewinięcia (nagłówek polecanych), a po doładowaniu
  // polecanych przewinięcie tylko tyle, żeby cały wiersz z przyciskiem był widoczny (nagłówek nie ucieka w górę).
  const reveal = (drawer) => {
    const scroller = drawer && drawer.querySelector('.drawer__scrollable');
    const recs = drawer && drawer.querySelector(RECS);
    if (!scroller || !recs || recs.hidden || !recs.getClientRects().length) return;
    const box = scroller.getBoundingClientRect();
    const r = recs.getBoundingClientRect();
    const down = Math.min(r.bottom - box.bottom, r.top - box.top);
    if (down > 0) scroller.scrollTop += down;
  };
  const keepPlace = (drawer, offset) => {
    const scroller = drawer && drawer.querySelector('.drawer__scrollable');
    const recs = drawer && drawer.querySelector(RECS);
    if (!scroller || !recs || offset === null || recs.hidden || !recs.getClientRects().length) return null;
    const align = () => {
      const now = recs.getBoundingClientRect().top - scroller.getBoundingClientRect().top;
      scroller.scrollTop += now - offset;
    };
    align();
    return recs;
  };

  // Polecane puste po dodaniu ostatniego produktu (Concept je chowa): pokaż dodaną pozycję na liście koszyka.
  const showLine = (drawer, key) => {
    const scroller = drawer && drawer.querySelector('.drawer__scrollable');
    const line = key && drawer ? drawer.querySelector(`#CartDrawer-Item-${CSS.escape(key)}`) : null;
    if (!scroller || !line) return;
    scroller.scrollTop += line.getBoundingClientRect().top - scroller.getBoundingClientRect().top;
    const link = line.querySelector('.horizontal-product__title');
    if (link) link.focus({ preventScroll: true });
  };

  document.addEventListener('click', async (event) => {
    const button = event.target instanceof Element ? event.target.closest(BUTTON) : null;
    if (!button) return;
    event.preventDefault();
    if (busy || button.getAttribute('aria-disabled') === 'true') return;

    const panel = button.closest(PANEL);
    const drawer = button.closest('cart-drawer');
    const host = drawer ? drawer.querySelector('.drawer__inner') || drawer : document.body;
    const checked = panel.querySelector('input[type="radio"]:checked');
    const id = Number(checked ? checked.value : button.getAttribute('data-variant-id'));
    const name = [button.getAttribute('data-motus-nazwa') || '', checked ? checked.getAttribute('data-motus-wariant') : ''].filter(Boolean).join(', ');
    const routes = (window.theme && window.theme.routes) || {};
    const pubsub = window.theme && window.theme.pubsub;
    const scroller = drawer && drawer.querySelector('.drawer__scrollable');
    const recsBefore = drawer && drawer.querySelector(RECS);
    const offset = scroller && recsBefore ? recsBefore.getBoundingClientRect().top - scroller.getBoundingClientRect().top : null;

    if (!id) return;
    showError(panel, '');
    busy = true;
    setLoading(button, true);
    try {
      const response = await fetch(`${routes.cart_add_url || '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }], sections: sectionsToRender(), sections_url: window.location.pathname }),
      });
      const parsed = await response.json();
      if (!response.ok || parsed.status) {
        const error = new Error(String(response.status));
        // 422 = komunikat Shopify w języku sklepu (np. brak kolejnych sztuk); inne błędy: własny tekst
        error.motusOpis = response.status === 422 && typeof parsed.description === 'string' ? parsed.description : '';
        throw error;
      }
      const key = parsed.items && parsed.items[0] ? parsed.items[0].key : null;
      const hasSections = parsed.sections && Object.keys(parsed.sections).length > 0;
      if (pubsub && hasSections) {
        const cart = await (await fetch(`${routes.cart_url || '/cart'}.js`, { headers: { Accept: 'application/json' } })).json();
        cart.sections = parsed.sections;
        pubsub.publish(pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'motus-polecane', productVariantId: id, cart });
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: parsed } }));
      } else if (drawer) {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } }));
      } else {
        window.location.reload();
        return;
      }
      const recs = keepPlace(drawer, offset);
      requestAnimationFrame(() => keepPlace(drawer, offset));
      if (recs) {
        const done = () => {
          if (recs.hidden || !recs.getClientRects().length) { showLine(drawer, key); return; }
          keepPlace(drawer, offset);
          reveal(drawer);
          const next = recs.querySelector(`${BUTTON}:not([tabindex="-1"])`);
          if (next) next.focus({ preventScroll: true });
        };
        // Concept chowa pustą listę zaraz po wstawieniu (product-complementary), więc sprawdzamy w następnej klatce.
        recs.addEventListener('recommendations:loaded', () => requestAnimationFrame(done), { once: true });
        recs.addEventListener('is-empty', () => showLine(drawer, key), { once: true });
      } else if (drawer) {
        // W-31: bloku "Akcesoria" nie ma już w odświeżonej szufladzie, więc pokaż dodaną pozycję na liście koszyka.
        requestAnimationFrame(() => showLine(drawer, key));
      }
      announce(host, ((window.motusTeksty || {}).dodano || 'Dodano do koszyka: {nazwa}').replace('{nazwa}', () => name));
    } catch (error) {
      if (button.isConnected) setLoading(button, false);
      if (panel.isConnected) showError(panel, (error && error.motusOpis) || (window.motusTeksty || {}).bladProduktu || 'Nie udało się dodać produktu. Spróbuj jeszcze raz.');
    } finally {
      busy = false;
    }
  });
})();

/*
 * MOTUS straż: usługa tylko razem z pojazdem (decyzja Mateusza 18.10.2026 „nie, nie można bez hulajnogi”).
 * Znacznik [data-motus-straz-uslug="klucz,klucz,"] rysuje snippets/motus-koszyk-uslugi.liquid w szufladzie i na /cart,
 * gdy w koszyku jest usługa, a nie ma pojazdu (szablon hulajnoga albo typ Hulajnoga elektryczna / Pojazd elektryczny).
 * a) Usługi wypadają z koszyka jednym /cart/update.js (ilość 0) z sekcjami koszyka (cart:bundled-sections), a szuflada,
 *    /cart i licznik w nagłówku odświeżają się mechanizmem Concepta (theme.pubsub cartUpdate). Działa przy wejściu na stronę
 *    (koszyk z samą usługą), po dodaniu samej usługi i po usunięciu hulajnogi z koszyka (jej usługi znikają razem z nią).
 * b) Komunikat ze znacznika zostaje po odświeżeniu: pod listą pozycji, a w pustym koszyku nad tekstem pustego koszyka.
 * c) "Dokończ transakcję": dopóki znacznik jest w koszyku, przycisk ma styl wyłączenia ze snippetu i aria-disabled, a wysłanie
 *    formularza przyciskiem name="checkout" jest zatrzymane (także z klawiatury) i uruchamia usunięcie usług.
 * Pułapkę fokusu Concepta po odświeżeniu zostawiamy tylko w otwartej szufladzie. Na /cart plik ładuje snippet usług
 * (context page), bo szuflady tam nie ma.
 */
(() => {
  if (window.motusStrazUslug) return;
  window.motusStrazUslug = true;

  const MARK = '[data-motus-straz-uslug]';
  const NOTE = '[data-motus-straz-komunikat]';
  const CHECKOUT = 'button[name="checkout"]';
  const proby = new Map();
  let busy = false;

  const sectionsToRender = () => {
    const sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections } }));
    return Array.from(new Set(sections));
  };

  const swapFromSections = (sections) => {
    Object.keys(sections).forEach((id) => {
      if (!sections[id]) return;
      const fresh = new DOMParser().parseFromString(sections[id], 'text/html');
      [`MiniCart-${id}`, `MainCart-${id}`].forEach((elementId) => {
        const current = document.getElementById(elementId);
        const next = fresh.getElementById(elementId);
        if (current && next) current.innerHTML = next.innerHTML;
      });
    });
  };

  const announce = (host, text) => {
    if (!host) return;
    let region = host.querySelector(':scope > .motus-straz-live');
    if (!region) {
      region = document.createElement('p');
      region.className = 'motus-straz-live sr-only';
      region.setAttribute('role', 'status');
      host.appendChild(region);
    }
    region.textContent = '';
    setTimeout(() => { region.textContent = text; }, 100);
  };

  // c) przyciski kasy w tym samym koszyku co znacznik
  const lock = () => {
    document.querySelectorAll(MARK).forEach((mark) => {
      const scope = mark.closest('cart-drawer') || mark.closest('main-cart') || document;
      scope.querySelectorAll(CHECKOUT).forEach((button) => button.setAttribute('aria-disabled', 'true'));
    });
  };

  // b) szuflada: pod listą pozycji albo w pustym koszyku; /cart: pod formularzem pozycji albo w pustym stanie strony
  const place = (html, inDrawer) => {
    const template = document.createElement('template');
    template.innerHTML = html;
    const note = template.content.firstElementChild;
    if (!note) return;
    note.removeAttribute('data-motus-straz-uslug');
    note.setAttribute('data-motus-straz-komunikat', '');
    document.querySelectorAll(NOTE).forEach((old) => old.remove());
    if (inDrawer) {
      // panel po id sekcji: [id^="MiniCart-"] łapie wcześniej przycisk zakładki (id MiniCart-<sekcja>-tab)
      const drawer = document.querySelector('cart-drawer');
      const mini = drawer && document.getElementById(`MiniCart-${drawer.getAttribute('data-section-id')}`);
      if (!mini) return;
      const list = mini.querySelector('cart-items');
      const scroller = list && list.closest('.drawer__scrollable');
      const empty = mini.querySelector('.drawer__empty');
      if (list && scroller && !scroller.classList.contains('hidden')) list.after(note);
      else if (empty) empty.prepend(note);
    } else {
      const form = document.querySelector('main-cart form.cart__form');
      const empty = document.querySelector('.cart .empty-state');
      if (form) form.after(note);
      else if (empty) empty.prepend(note);
    }
  };

  // a)
  const run = async () => {
    const mark = document.querySelector(MARK);
    if (!mark || busy) return;
    lock();
    const keys = (mark.getAttribute('data-motus-straz-uslug') || '').split(',').filter(Boolean);
    const sig = keys.join(',');
    if (!keys.length || (proby.get(sig) || 0) >= 2) return;
    proby.set(sig, (proby.get(sig) || 0) + 1);

    busy = true;
    const drawer = mark.closest('cart-drawer');
    const html = mark.outerHTML;
    const host = drawer ? drawer.querySelector('.drawer__inner') || drawer : mark.closest('.cart') || document.body;
    const routes = (window.theme && window.theme.routes) || {};
    const pubsub = window.theme && window.theme.pubsub;
    const updates = {};
    keys.forEach((key) => { updates[key] = 0; });
    try {
      const response = await fetch(`${routes.cart_update_url || '/cart/update'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ updates, sections: sectionsToRender(), sections_url: window.location.pathname })
      });
      const cart = await response.json();
      if (!response.ok || cart.status) throw new Error(String(response.status));
      const hasSections = cart.sections && Object.keys(cart.sections).length > 0;
      if (pubsub && hasSections) {
        pubsub.publish(pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'motus-straz', cart });
      } else if (hasSections) {
        swapFromSections(cart.sections);
      } else if (drawer) {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } }));
      } else {
        window.location.reload();
        return;
      }
      if (!(drawer && drawer.hasAttribute('open')) && window.theme && window.theme.a11y) window.theme.a11y.removeTrapFocus();
      place(html, Boolean(drawer));
      requestAnimationFrame(() => { if (!document.querySelector(NOTE)) place(html, Boolean(drawer)); });
      announce(host, (window.motusTeksty || {}).uslugaUsunieta || 'Usługa usunięta z koszyka. Usługę dodajesz razem z pojazdem.');
    } catch (error) {
      // znacznik zostaje w koszyku, więc kasa dalej zablokowana; kolejna próba przy następnym odświeżeniu koszyka
    } finally {
      busy = false;
    }
  };

  let frame = null;
  const schedule = () => {
    if (frame !== null) return;
    frame = requestAnimationFrame(() => {
      frame = null;
      run();
    });
  };

  // c) wysłanie formularza do kasy (klik, Enter) zatrzymane, dopóki w tym koszyku jest znacznik albo trwa usuwanie
  document.addEventListener('submit', (event) => {
    const submitter = event.submitter || document.activeElement;
    if (!(submitter instanceof Element) || submitter.getAttribute('name') !== 'checkout') return;
    const scope = submitter.closest('cart-drawer') || submitter.closest('main-cart') || document;
    if (!busy && !scope.querySelector(MARK)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    run();
  }, true);

  // znacznik pojawia się przy wejściu na stronę i po każdym przerysowaniu koszyka (szuflada, /cart, cart:refresh)
  new MutationObserver((mutations) => {
    if (mutations.some((mutation) => mutation.addedNodes.length)) schedule();
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('cart:updated', schedule);
  document.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('load', schedule);
  if (document.readyState === 'complete') schedule();
})();
